import { index, pgTable, text, timestamp } from 'drizzle-orm/pg-core'
import { relations } from 'drizzle-orm'
import { id, createdAt } from '../utils/columns'
import { entityUsers } from '../entities/entities.schema'

export const refreshTokens = pgTable(
  'refresh_tokens',
  {
    id,
    entityUserId: text('entity_user_id')
      .notNull()
      .references(() => entityUsers.id, { onDelete: 'cascade' }),
    expiresAt: timestamp('expires_at').notNull(),
    createdAt,
  },
  (table) => {
    return [
      index('idx_refresh_tokens_entity_user_id').on(table.entityUserId),
      index('idx_refresh_tokens_expires_at').on(table.expiresAt),
    ]
  },
)

export type RefreshToken = typeof refreshTokens.$inferSelect
export type RefreshTokenInsert = typeof refreshTokens.$inferInsert

export const refreshTokensRelations = relations(refreshTokens, ({ one }) => ({
  entityUser: one(entityUsers, {
    fields: [refreshTokens.entityUserId],
    references: [entityUsers.id],
  }),
}))
